<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">
        <el-row :span="24">
          <el-col :span="12">

            <el-form-item prop="recordDate" label="日期">
              <el-date-picker v-model="formData.recordDate" placeholder="请选择日期" type="date" clearable
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

          </el-col>

          <el-col :span="12">
            <el-form-item prop="photovoltaic" label="光伏发电">
              <el-input clearable v-model="formData.photovoltaic" placeholder="请输入光伏发电" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="exhaust" label="废气">
              <el-input clearable v-model="formData.exhaust" placeholder="请输入废气" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="exhaustPurified" label="废气净化">
              <el-input clearable v-model="formData.exhaustPurified" placeholder="请输入废气净化" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="sewage" label="污水">
              <el-input clearable v-model="formData.sewage" placeholder="请输入污水" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="sewagePurified" label="净化污水">
              <el-input clearable v-model="formData.sewagePurified" placeholder="请输入净化污水" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="waterUsage" label="用水">
              <el-input clearable v-model="formData.waterUsage" placeholder="请输入用水" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="electricityUsage" label="用电">
              <el-input clearable v-model="formData.electricityUsage" placeholder="请输入用电" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="useNaturalGas" label="用天然气">
              <el-input clearable v-model="formData.useNaturalGas" placeholder="请输入用天然气" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="useSteam" label="用蒸汽">
              <el-input clearable v-model="formData.useSteam" placeholder="请输入用蒸汽" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="rainwaterTreatment" label="雨水处理">
              <el-input clearable v-model="formData.rainwaterTreatment" placeholder="请输入雨水处理" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload :has-remove="hasRemove" v-model="formData.fileList"></file-upload>
              <!-- <div class="row-wrap">

                <div class="images-wrap" v-for="(item, index) of formData.fileList" :key="index">
                  <i class="el-icon-error close-icon" @click="delImage(index)"></i>
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>

                <el-upload class="upload-demo" :show-file-list="false" :action="$apis.common.uploadUrl"
                  :on-success="handleSuccess" :before-upload="beforeUpload" list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不能超过10MB~
                  </div>
                </el-upload>
              </div> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'GreenEnrgyAdd',

  data () {
    return {
      formData: {

        recordDate: '',
        photovoltaic: '',
        exhaust: '',
        exhaustPurified: '',
        sewage: '',
        sewagePurified: '',
        waterUsage: '', // 用水
        electricityUsage: '', // 用电
        useNaturalGas: '', // 用天然气
        useSteam: '', // 用蒸汽
        rainwaterTreatment: '', // 雨水处理
        fileList: []
      },

      rules: {
        recordDate: [
          {
            required: true,
            message: '请选择日期',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,
      userList: []

    }
  },
  created () {
    if (this.energyId) {
      this.loadData()
    }
  },
  computed: {
    energyId () {
      return this.$route.query.energyId
    },
    buttonList () {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasRemove() {
      return this.buttonList.includes('removefile')
    },
    fileImgUrl () {
      const arr = this.formData.fileList.map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.greenEnergy.selectPaGreenEnergyByEnergyId, {
          params: { energyId: this.energyId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleSuccess (res) {
      this.formData.fileList.push(res.data)
    },
    delImage (index) {
      this.formData.fileList.splice(index, 1)
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.greenEnergy.insertPaGreenEnergy
          if (this.energyId) {
            url = this.$apis.greenEnergy.updatePaGreenEnergy
          }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
